import React from "react";
import {KatBox, KatCard, KatLink} from "@amzn/katal-react";
import {useTranslation} from "react-i18next";
import {IOperationMetadata} from "src/context/models/Metadata";

type Props = {
    metadata: IOperationMetadata
};

export const MetadataCard: React.FC<Props> = ({
                                                  metadata
                                              }) => {
    const {t} = useTranslation();
    if (!metadata) {
        return null;
    }
    return (
        <KatCard className="metadata-card" title={t("Operation Metadata -")}>
            <div>
                <KatBox>
                    <p><b>{`${t("Category - ")}`}</b> {`${metadata.category}`}</p>
                    <p><b>{`${t("Type - ")}`}</b> {`${metadata.type}`}</p>
                    <p><b>{`${t("Item - ")}`}</b> {`${metadata.item}`}</p>
                </KatBox>

                <p><b>{`${t("Group - ")}`}</b> {`${metadata.group}`}</p>
                <p><b>{`${t("ServiceName - ")}`}</b> {`${metadata.serviceName}`}</p>
                <KatLink
                    href={`https://t.corp.amazon.com/issues?q=extensions.tt.status%3A%28Assigned%20OR%20Researching%20OR%20%22Work%20In%20Progress%22%20OR%20Pending%29%20AND%20currentSeverity%3A%281%20OR%202%20OR%203%20OR%204%20OR%205%20OR%202.5%20OR%20N%29%20AND%20extensions.tt.category%3A${metadata.category}%20AND%20extensions.tt.type%3A${metadata.type}%20AND%20extensions.tt.item%3A${metadata.item}`}
                    label={t("Ticket Queue")} variant="link"/>
            </div>
        </KatCard>)
}